import { useEffect, useState } from 'react';
import { BEFORE_UPDATE_EVENT } from '../lib/updateToast';
import { parseShareUrl } from '../lib/export';

export const MAP_VIEW_KEY = 'ultimate-gis:map-view';

/** A shared link's hash (#lat=..&lon=..&zoom=..) as a restored view; layers become layerIds when listed. */
export function viewFromShareHash(hash) {
  const v = parseShareUrl(hash);
  if (!v) return null;
  const { layers, ...view } = v;
  return layers.length ? { ...view, layerIds: layers } : view;
}

function readAndClear() {
  try {
    const raw = sessionStorage.getItem(MAP_VIEW_KEY);
    if (!raw) return typeof window !== 'undefined' ? viewFromShareHash(window.location.hash) : null;
    sessionStorage.removeItem(MAP_VIEW_KEY);
    const v = JSON.parse(raw);
    return v && Number.isFinite(v.latitude) && Number.isFinite(v.longitude) ? v : null;
  } catch { return null; }
}

/**
 * Persist the map view across an "Update now" reload.
 * getView: () => {latitude, longitude, zoom, bearing, pitch, layerIds?} | null
 * Returns the restored view (or null), read once on mount: the pre-update view from
 * sessionStorage, else the view in a shared link's hash (Share > Copy Link).
 */
export function useMapViewPersistence(getView) {
  const [restored] = useState(readAndClear);

  useEffect(() => {
    const flush = () => {
      try {
        const v = getView();
        if (v) sessionStorage.setItem(MAP_VIEW_KEY, JSON.stringify(v));
      } catch { /* best effort */ }
    };
    window.addEventListener(BEFORE_UPDATE_EVENT, flush);
    return () => window.removeEventListener(BEFORE_UPDATE_EVENT, flush);
  }, [getView]);

  return restored;
}
